export enum WebView {
  MOBILE = "MOBILE",
  DESKTOP = "DESKTOP",
  NOT_SELECTED = "NOT_SELECTED"
}
